import React from 'react'
import { ThemeContextProvider } from './src/context/themeContext'
import GlobalStyles from './src/components/Layout/globalStyles'

export const wrapRootElement = ({ element }) => {
   return <ThemeContextProvider>{element}</ThemeContextProvider>
}

export const wrapPageElement = ({ element }) => {
   return (
      <>
         <GlobalStyles />
         {element}
      </>
   )
}

export const onClientEntry = async () => {
   if (typeof IntersectionObserver === `undefined`) {
      await import(`intersection-observer`)
   }
}

const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

const scrollToElement = (hash) => {
   const element = document.querySelector(hash)
   if (element) {
      element.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' })
      return
   }
   scrollToTop()
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation) return;

  const isNewPath = location.pathname !== prevLocation.pathname;
  const hasHash = !!location.hash;

  setTimeout(() => {
    if (isNewPath) {
      hasHash ? scrollToElement(location.hash) : scrollToTop();
    }
    // If same route, do nothing (let browser handle default or smooth scroll)
  }, 0);
};